import styled from '@emotion/styled';
export const CardContainer = styled.div`
  background-color: var(--my-card-background);
  overflow: hidden;
  box-shadow: var(--theme-shadow);
  border: 1px solid var(--theme-border);
  cursor: pointer;
  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;
  min-height: 110px;

  @media (max-width: 400px) {
    min-height: auto;
  }

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-color: var(--theme-border-light);
  }
`;
export const CardContent = styled.div`
  padding: 12px 16px;

  @media (max-width: 400px) {
    padding: 10px 12px;
  }
  @media (max-width: 350px) {
    padding: 6px 8px;
  }
`;
export const HeaderWrapper = styled.div`
  margin-bottom: 8px;

  @media (max-width: 400px) {
    margin-bottom: 4px;
  }
  @media (max-width: 350px) {
    margin-bottom: 0px;
  }
`;
export const BodyWrapper = styled.div``;
export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-bottom: 6px;

  @media (max-width: 400px) {
    flex-wrap: wrap;
    margin-bottom: 4px;
  }
  @media (max-width: 350px) {
    gap: 4px;
    margin-bottom: 0px;
  }
`;
export const Title = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.4;
  color: var(--theme-text);

  @media (max-width: 400px) {
    font-size: 0.95rem;
  }
  @media (max-width: 350px) {
    font-size: 0.9rem;
    line-height: 1.2;
  }
`;
export const Description = styled.p`
  font-size: 0.875rem;
  color: var(--theme-text-secondary);
  line-height: 1.5;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 400px) {
    font-size: 0.8rem;
    -webkit-line-clamp: 2;
    margin-bottom: 10px;
  }
  @media (max-width: 350px) {
    font-size: 0.75rem;
    line-height: 1.4;
    margin-bottom: 4px;
  }
`;
export const MediaGridWrapper = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
  width: 100%;
  aspect-ratio: 960 / 280;
  overflow: hidden;
  border-radius: 8px;
  background: oklch(0.96 0.012 85);
`;
export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  width: 100%;
  gap: 8px;

  @media (max-width: 400px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  @media (max-width: 350px) {
    gap: 6px;
    margin-top: 10px;
  }
`;
export const LeftFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  overflow: hidden;
`;
export const RightFooter = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 400px) {
    gap: 8px;
    justify-content: flex-start;
    width: 100%;
    flex-shrink: 1;
  }

  @media (max-width: 350px) {
    gap: 6px;
  }
`;
export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
  display: block;
  border-radius: 8px;
`;
